import classNames from "classnames/bind";
import styles from "common/buttons/CancelOrSubmit.module.css";
import { AbortButton } from "common/components/forms/AbortButton";
import { SubmitButton } from "common/components/forms/SubmitButton";
import * as React from "react";

const classNameBuilder = classNames.bind(styles);

interface Props {
  onCancel: () => void;
  isLoading?: boolean;
  showSubmit?: boolean;
  submitText?: string;
  withSpacing?: boolean;
  cancelText?: string;
}

export const CancelOrSubmit: React.FC<React.PropsWithChildren<Props>> = ({
  onCancel,
  isLoading,
  showSubmit = true,
  submitText = "Opprett",
  withSpacing = true,
  cancelText,
}) => {
  const classes = classNameBuilder({
    withSpacing,
  });

  return (
    <div className={classes}>
      <AbortButton onClick={onCancel}>{cancelText}</AbortButton>
      {showSubmit && (
        <SubmitButton kind={isLoading ? "disabled" : "primary"}>
          {submitText}
        </SubmitButton>
      )}
    </div>
  );
};
